import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { FormField, Select } from '@legalshield/adonis-ux-framework';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  required?: boolean;
  options: { title: string; value: string }[];
  placeholder?: string;
};

const SelectField = <T extends FieldValues>({ control, name, label, required, options, placeholder }: Props<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => (
      <FormField
        id={String(name)}
        label={label}
        required={required}
        status={fieldState.error ? 'invalid' : undefined}
        validationHint={fieldState.error?.message}
      >
        <Select
          placeholder={placeholder ?? `Select ${label}`}
          placeholderValue=""
          value={(field.value as string | undefined) ?? ''}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => field.onChange(e.target.value)}
          options={options.map((o) => ({ label: o.title, value: o.value }))}
        />
      </FormField>
    )}
  />
);

export default SelectField;
